import React, { useState, useEffect, useRef } from "react";
import apiService from "../../services/api.service";
import ImageGallery from "../imageGallery";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addItem, removeItem, selectCartItems, setCompanyData } from "../../Redux/shoppingCartReducer";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import StorageSessionService from "../../services/storage.service";
import SendTo from "../../components/SendTo";
import { eventService } from "../../services/event.service";
import DropdownCheckbox from "../../components/DropdownCheckbox";
import ProductDetailsRows from "../../components/ProductDetailsRows";
import Company from "./Company";
import { useTranslation } from "../../hooks/useTranslation";
import Select from 'react-select';
import TextareaWithCounter from "../TextareaWithCounter";
import DropdownCheckboxGeneric from "../../components/DropdownCheckboxGeneric";

function CompanyProductComponent() {
    const paymentStep = useSelector((state) => state.cart.payment.payload)
    const [sendToWorkers, setSendToWorkes] = useState(false)
    const [product, setProduct] = useState([]);
    const [lang, setLang] = useState("");
    const { t, tHtml } = useTranslation();
    const workers = useSelector((state) => state.company.workers)
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const itemsCount = useSelector((state) => state.cart.itemCount)
    const productsFromSession = window.sessionStorage.getItem("products");
    const chainId = new URLSearchParams(location.search).get("chainid") || 0;
    const propertyId = new URLSearchParams(location.search).get("propid") || 0;
    const LastfreePriceChosenKey = 'LastfreePriceChosen';
    const sessionService = new StorageSessionService();
    const companyUser = useSelector((state) => state.company.companyUser)
    const company = useSelector((state) => state.company.company)
    let cartItems = useSelector(selectCartItems);
    cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
    const [dropdownState, setDropdownState] = useState(false)
    const dropdownButtonRef = useRef(null)
    const [allWorkers, setAllWorkers] = useState([])
    const [isWorkersAmountValid, setIsWorkersAmountValid] = useState(true)
    const [workersEmailValidation, setWorkersEmailValidation] = useState({workers: [], isValid: true})
    const [invalidProductAmount, setInvalidProductAmount] = useState(false)
    const [allGreetings, setAllGreetings] = useState([])
    const [greetingText, setGreetingText] = useState("")

    const SetLanguage = (l) => {
        i18next.changeLanguage(l);
    };

    const getGreetingText = (greetingId) => {
        const greeting = allGreetings.find(g => g.greetingId === greetingId);
        return greeting?.translations?.find(t => t.isoLanguageCode == i18next.language)?.greetingText ?? '';
    };

    useEffect(() => {
        if (sessionStorage.getItem('products')) {
            let products = JSON.parse(sessionStorage.getItem('products'))
            if ((Object.keys(products)[0] === 'undefined')) {
                addItemToCart()
            }
        } else {
            addItemToCart()
        }
    }, [product])

    useEffect(() => {
        if (company) {
            apiService.getCompanyWorkers(company.companyId).then((response) => {
                setAllWorkers(response.data?.data)
            })
            apiService.getGreetings({companyId: company.companyId, chainId: chainId, includeTranslations: true}).then((response) => {
                setAllGreetings(response.data?.data)
            })
        }
    }, [])

    useEffect(() => {
        if (company) {
            setLang(new URLSearchParams(location.search).get("lang") || "eng");
            const selectedProductId = new URLSearchParams(location.search).get("pid") || 0;
            getProducts(selectedProductId);
            if (window.parent === window.self) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                console.info("Prod page window.parent === window.self");
            } else {
                console.info('dispatch event to scroll!');
                window.parent.postMessage({ toScroll: true }, '*');
            }
        }
    }, []);

    useEffect(() => {
        SetLanguage(lang);
    }, [lang]);

    useEffect(() => {
        if(!workersEmailValidation.isValid || !isWorkersAmountValid){
            validateWorkers();
        }
    }, [workers])

    const toggleDropdown = () => {
        dropdownState ? setDropdownState(false) : setDropdownState(true)
    }

    const closeDropdown = () => {
        setDropdownState(false)
    }

    const getProducts = (selectedProductId) => {
        apiService.getProducts(chainId, propertyId, true, selectedProductId).then(
            (response) => {

                let currentproduct = response.data.data;
                sessionService.getSessionStorage(LastfreePriceChosenKey).then(res => {
                    let lastLastfreePriceChosen = res || null;
                    if (lastLastfreePriceChosen) {
                        currentproduct[0].productPrice = parseInt(lastLastfreePriceChosen);
                    }
                    setProduct(currentproduct[0]);
                });
            },
            (error) => {
                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
            }
        );
    };

    const addItemToCart = () => {
        dispatch(addItem({ selectedProduct: product }));
        if (product.productTypeId !== window.productTypeIdGoods && !companyUser) {
            blockProduct(1);
        }
    };

    const gotoReg = () => {
        if (itemsCount > 0) {
            dispatch(setCompanyData({ greetingText: greetingText }));

            if(sendToWorkers && !validateWorkers()){
                return; //workers amount / emails is not valid
            }

            blockProduct(itemsCount);
        }
    }

    const validateWorkers = () => {
        const workersMissingEmail = workers.filter(w => !w.workerEmail);
        const isValid = workersMissingEmail.length === 0;
        setWorkersEmailValidation({workers: workersMissingEmail, isValid: isValid}); 

        const isAmountValid = workers && workers.length === itemsCount;
        setIsWorkersAmountValid(isAmountValid);

        return isValid && isAmountValid;            
    }

    const blockProduct = (amount) => {
        sessionStorage.removeItem('productBlockingIdentifier');
        apiService.blockProduct(product.productId, amount).then(
            (response) => {

                let productBlockingIdentifier = response.data;
                if (productBlockingIdentifier) {
                    sessionStorage.setItem('productBlockingIdentifier', productBlockingIdentifier);
                    sessionStorage.setItem('productBlockingIdentifierTime', new Date().toISOString());
                    history.push(`/registrastion?chainid=${chainId}&lang=${lang}`);
                    eventService.addToCart();
                }
                else {
                    alert(t("ProdNotAvail"));
                }
            },
            (error) => {
                console.log(error)
                alert(t("ProdNotAvail"));
            }
        );
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            toggleDropdown()
        }
        if (e.keyCode === 27) {
            closeDropdown()
        }
    }

    const insertNewSearch = (prod) => {
        apiService.insertSearch(prod.productId, null, null, null, true, new Date().toISOString());
        sessionStorage.removeItem('lastOrderNum');
        sessionStorage.removeItem('lastCustomer');
        sessionStorage.removeItem('payerName');
    }
    const removeItemFromCart = () => {
        if (itemsCount > 1) {
            dispatch(removeItem({ productId: product.productId }))
        }
    };

    const getProductTranslations = (prod) => {
        if (prod && prod.translations) {
            let ProductTranslations = prod.translations.filter((p) => {
                return p.languageIsoCode == lang && p.propductId == prod.propductId;
            });
            return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
        }
        return {};
    };


    return (
        <>
            <div className="comp-prod-greeting hidden-desk">
                <Company />
            </div>
            <Row className="comp-prod-heading border-underline-big">
                <Col className="name align-content-center" role="heading" aria-label={getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName }}></Col>
                <Col className="price hidden-mobile justify-content-end">
                    <Link aria-label={t("BackToProductsList")} className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} >{t("BackToProductsList")}</Link>
                </Col>
            </Row>
            {/* product details box  */}
            <Row className="comp-product">
                <Col sm={12} md={6} className="shop-item">
                    <ImageGallery product={product || null} images={product.images || []} />
                    <div className="descr-wrap pt-4 w-100" dangerouslySetInnerHTML={{ __html: getProductTranslations(product)?.productDescription }}></div>
                    
                </Col>
                <Col sm={12} md={6} >
                    <div className="descr-wrap">
                        <Row className="btns-wrap">

                            <Col sm={7}>
                                <ProductDetailsRows
                                    product={product}
                                    itemsCount={itemsCount}
                                    addItemToCart={addItemToCart}
                                    removeItemFromCart={removeItemFromCart}
                                    invalidProductAmount={invalidProductAmount}
                                />
                            </Col>

                            <Col sm={12}>
                               {!!companyUser && !!itemsCount && 
                                    <>
                                         {/* workers select */}
                                         <div>
                                            <h3 aria-label={t("SendVouchersTo")} className="comp-gift-to">{t("SendVouchersTo")}</h3>
                                            <SendTo
                                                paymentStep={paymentStep}
                                                setSendToWorkes={setSendToWorkes}
                                            />
                                            {sendToWorkers &&
                                                <div className="search-worker-wrapper">
                                                    <div ref={dropdownButtonRef} onKeyDown={e => handleKeyPress(e)} className="search-worker" onClick={e => toggleDropdown(e)}>
                                                        <i>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683417 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#333333" />
                                                            </svg>
                                                        </i>
                                                        <input type="button" className="text-end" value={t("YouChose") + " " + workers.length + " " + t("Recipients")} />
                                                    </div>
                                                    {dropdownState &&
                                                        <DropdownCheckbox
                                                            allWorkers={allWorkers}
                                                            closeDropdown={closeDropdown}
                                                            dropdownButtonRef={dropdownButtonRef}
                                                        />
                                                    }
                                                    {!isWorkersAmountValid &&
                                                        <div role="alert" className="text-danger bold">{t("Choose")} {itemsCount} {t("Recipients")}</div>
                                                    }
                                                    {!workersEmailValidation.isValid &&
                                                        <div role="alert" className="text-danger bold">{t("InvalidWorkersContactError")} {workersEmailValidation.workers.map(w => (w.workerFirstName + " " + w.workerLastName)).join(", ")}</div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        {/* greetings select */}
                                        <div className="greetings-wrap">
                                            <div className="greetings-info">
                                                {tHtml("AddGreetingsToProduct")}
                                            </div>
                                            <DropdownCheckboxGeneric
                                                items={allGreetings.map(greeting => ({ value: greeting.greetingId, label: greeting.greetingName }))}
                                                onChange={(selectedOption) => {
                                                    setGreetingText(getGreetingText(selectedOption.value));
                                                }}
                                                title={t("SelectGreeting")}
                                                maxSelection={1}
                                            />
                                            <TextareaWithCounter
                                                id="GiftFreeTextInput"
                                                name="GiftFreeTextInput"
                                                value={greetingText}
                                                onChange={(e) => setGreetingText(e.target.value)}
                                                maxLength={200}
                                                clearLabel={t("Delete")}
                                            />
                                        </div>
                                        <div className="book-btn text-start mt-4">
                                            <button aria-label={t("Book")} className="btn long order-btn mb-4" onClick={e => gotoReg()}>{t("Continue")}</button>
                                        </div>
                                    </>
                                }
                            </Col>
                        </Row>
                    </div>
                        
                    <Col sm={12} className="text-start mt-4 p-4 hidden-desk"><Link aria-label={t("BackToProductsList")} className="btn white mobile-back-btn" to={`/?chainid=${chainId}&lang=${lang}`} >{t("BackToProductsList")}</Link></Col>

                </Col>
            </Row>
        </>
    );
}

export default CompanyProductComponent;
